import { useState } from 'react';

import PropTypes from 'prop-types';

import { useTargetingVocabulary } from '../../../models/targeting/queries';

import { AudienceCriteriaCard } from './AudienceCriteriaCard';
import { ManagementCriteriaCard } from './ManagementCriteriaCard';

/**
 * The targeting cards of an HR search. While targeting search is switched off only the company-kind
 * filter remains (it comes from the register, not from the website profile).
 */
export const TargetingCriteriaCards = ({ filters, onFilterChange }) => {
	const { data: vocabulary } = useTargetingVocabulary();
	const [open, setOpen] = useState({ audience: false, management: false });
	const toggle = (key) => setOpen((prev) => ({ ...prev, [key]: !prev[key] }));

	if (!vocabulary) return null;
	const targetingEnabled = Boolean(vocabulary.searchEnabled);

	return (
		<>
			{(targetingEnabled || vocabulary.companyKinds?.length > 0) && (
				<AudienceCriteriaCard
					filters={filters}
					onFilterChange={onFilterChange}
					vocabulary={vocabulary}
					targetingEnabled={targetingEnabled}
					open={open.audience}
					onToggle={() => toggle('audience')}
				/>
			)}
			{targetingEnabled && (
				<ManagementCriteriaCard
					filters={filters}
					onFilterChange={onFilterChange}
					vocabulary={vocabulary}
					open={open.management}
					onToggle={() => toggle('management')}
				/>
			)}
		</>
	);
};

TargetingCriteriaCards.propTypes = {
	filters: PropTypes.object.isRequired,
	onFilterChange: PropTypes.func.isRequired,
};
